import { ChevronDown } from "lucide-react";

export default function SectionHeader({ title }) {
  return (
    <div className="my-8" data-testid={`section-header-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="divider-diamond mb-4">
        <span className="text-2xl">◆</span>
        <h2 className="fire-title text-3xl md:text-5xl tracking-[0.15em]">{title.toUpperCase()}</h2>
        <span className="text-2xl">◆</span>
      </div>
    </div>
  );
}

export function ScrollChevron() {
  return (
    <div className="flex justify-center my-8">
      <ChevronDown size={32} className="scroll-arrow" />
    </div>
  );
}
